export class TrabajadorEntity {
    constructor() {
    }

    public trabajador_id: string = null;
    public trabajador_trabajador: string = null;
    public trabajador_clave: string = null;
    public trabajador_nombres: string = null;
    public trabajador_apellidos: string = null;
    public trabajador_dni: string = null;
    public trabajador_direccion: string = null;
    public trabajador_correo: string = null;
    public trabajador_celular: string = null;
    public trabajador_checksum: string = null;
    public trabajador_estado: string = null;
    public cliente_id: string = null;
    public trabajador_accesoabackoffice: string = null;
    public rol_id: number = null;
    public puesto_nombre: string = null;
    public trabajador_provincia: string = null;
    public trabajador_civil: string = null;
    public trabajador_grado: string = null;
    public trabajador_numeroemergencia: string = null;
    public trabajador_email: string = null;
    public trabajador_lugar: string = null;
    public trabajador_foto: string = null;
    public hasMovilidad = false;
    public trabajador_bloqueomovilidad: string = null ;

    public getTrabajador_id(): string {
        return this.trabajador_id;
    }

    public setTrabajador_id(value: string) {
        this.trabajador_id = value;
    }

    public getTrabajador_trabajador(): string {
        return this.trabajador_trabajador;
    }

    public setTrabajador_trabajador(value: string) {
        this.trabajador_trabajador = value;
    }

    public getTrabajador_clave(): string {
        return this.trabajador_clave;
    }

    public setTrabajador_clave(value: string) {
        this.trabajador_clave = value;
    }

    public getTrabajador_nombres(): string {
        return this.trabajador_nombres;
    }

    public setTrabajador_nombres(value: string) {
        this.trabajador_nombres = value;
    }

    public getTrabajador_apellidos(): string {
        return this.trabajador_apellidos;
    }

    public setTrabajador_apellidos(value: string) {
        this.trabajador_apellidos = value;
    }

    public getTrabajador_dni(): string {
        return this.trabajador_dni;
    }

    public setTrabajador_dni(value: string) {
        this.trabajador_dni = value;
    }

    public getTrabajador_direccion(): string {
        return this.trabajador_direccion;
    }

    public setTrabajador_direccion(value: string) {
        this.trabajador_direccion = value;
    }

    public getTrabajador_correo(): string {
        return this.trabajador_correo;
    }

    public setTrabajador_correo(value: string) {
        this.trabajador_correo = value;
    }

    public getTrabajador_celular(): string {
        return this.trabajador_celular;
    }

    public setTrabajador_celular(value: string) {
        this.trabajador_celular = value;
    }

    public getTrabajador_checksum(): string {
        return this.trabajador_checksum;
    }

    public setTrabajador_checksum(value: string) {
        this.trabajador_checksum = value;
    }

    public getTrabajador_estado(): string {
        return this.trabajador_estado;
    }

    public setTrabajador_estado(value: string) {
        this.trabajador_estado = value;
    }

    public getCliente_id(): string {
        return this.cliente_id;
    }

    public setCliente_id(value: string) {
        this.cliente_id = value;
    }

    public getTrabajador_accesoabackoffice(): string {
        return this.trabajador_accesoabackoffice;
    }

    public setTrabajador_accesoabackoffice(value: string) {
        this.trabajador_accesoabackoffice = value;
    }

    public getRol_id(): number {
        return this.rol_id;
    }

    public setrol_id(rol_id: number) {
        this.rol_id = rol_id;
    }

    public getPuesto_nombre(): string {
        return this.puesto_nombre;
    }

    public setPuesto_nombre(value: string) {
        this.puesto_nombre = value;
    }

    public toString(): string {
        return this.getTrabajador_id();
    }
}
